// extracted by mini-css-extract-plugin
export var arrows = "_5l-5";
export var decrementer = "_5l-9";
export var disabled = "_5l-3";
export var error = "_5l-1";
export var hiddenText = "_5l-a";
export var incrementer = "_5l-8";
export var input = "_5l-7";
export var inputWrapper = "_5l-0";
export var readonly = "_5l-2";
export var regular = "_5l-6";
export var small = "_5l-4";